module.exports = "/_next/static/resources/hero-2-d4d5582dabd7d65e47621df01b54d597.jpg";